import apiClient from './api';



async function createOrUpdateCartItem(data) {
  try {
    const response = await apiClient.post('/create-update-cart-item', data);
    return { success: true, data: response.data };
  } catch (error) {
    if (error.response) {
      return { success: false, message: error.response.data.message || 'Error', details: error.response.data };
    }
    if (error.request) {
      return { success: false, message: "No response received" };
    }
    return { success: false, message: error.message };
  }
}


async function removeTicketFromCart(data) {
  try {
    const response = await apiClient.post('/remove-ticket-from-cart', data);
    return { success: true, data: response.data };
  } catch (error) {
    if (error.response) {
      return { success: false, message: error.response.data.message || 'Error', details: error.response.data };
    }
    if (error.request) {
      return { success: false, message: "No response received" };
    }
    return { success: false, message: error.message };
  }
}


async function getCart(){
  try {
    const response = await apiClient.get(`/get-cart`);
    return response.data; 
  } catch (error) {
    throw error;
  }
}

async function fetchCartCount(){
  try {
    const response = await apiClient.get(`/fetch-cart-count`);
    return response.data; 
  } catch (error) {
    throw error;
  }
}

export {createOrUpdateCartItem, getCart, fetchCartCount, removeTicketFromCart };